module.exports = __webpack_public_path__ + "static/media/right_decor.6817b739.png";